import { render, staticRenderFns } from "./SharedFilesTable.vue?vue&type=template&id=b6ad523c&scoped=true&"
import script from "./SharedFilesTable.vue?vue&type=script&lang=js&"
export * from "./SharedFilesTable.vue?vue&type=script&lang=js&"
import style0 from "./SharedFilesTable.vue?vue&type=style&index=0&id=b6ad523c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ad523c",
  null
  
)

export default component.exports